import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: theme.spacing(1),
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    background: 'transparent',
    width: 'auto',
  },
  message: {
    flexGrow: 1,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    fontSize: 14,
    color: theme.palette.text.primary,
  },
  info: {
    borderColor: theme.palette.info.main,
  },
  success: {
    borderColor: theme.palette.success.main,
  },
  warning: {
    borderColor: theme.palette.warning.main,
  },
  error: {
    borderColor: theme.palette.error.main,
  },
  close: {
    cursor: 'pointer',
  },
}));

export default useStyles;
